import React from "react";
import { Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const UploadFile = ({
  label,
  handleFileChange,
  name,
  accept = "image/*,video/*,audio/*,application/pdf",
}) => {
  return (
    <Button
      component="label"
      variant="contained"
      sx={{ fontSize: "11px" }}
      fullWidth
      startIcon={<UploadFileIcon />}
    >
      {label}
      <input
        type="file"
        name={name}
        accept={accept}
        hidden
        onChange={handleFileChange}
      />
    </Button>
  );
};

export default UploadFile;
